import React, { useEffect, useState } from 'react'
import IonIcon from '@reacticons/ionicons'
import { getStorebyID } from '../../../services/data'
import { useLocation, useParams } from 'react-router-dom'

const PublishTab = ({
  checkType,
  storeName,
  scriptCode,
  copied,
  handleCopy,
  isDomainVerified
}) => {
  const [storeData, setStoreData] = useState(null)

  const location = useLocation()
  const params = useParams()

  // ✅ Extract store_id from URL (params or pathname)
  const getStoreIdFromUrl = () => {
    if (params?.store_id) return params.store_id
    const pathParts = location.pathname.split('/')
    console.log('Path parts:', pathParts)
    return pathParts[1] || null
  }

  const storeid = getStoreIdFromUrl()

  useEffect(() => {
    if (storeid) {
      getStorebyID(storeid)
        .then(res => {
          if (res) {
            setStoreData(res)
          }
        })
        .catch(err => {
          console.error('Error fetching store:', err)
        })
    }
  }, [storeid])



  return (
    <div className='flex flex-col space-y-3 mb-5 w-full'>
      <>
        {storeData?.data?.type === 'shopify' ? (
          <div className='w-full max-w-[500px] overflow-clip'>
            <div className='mr-4 rounded-lg'>
              <h3 className='text-lg font-semibold'>Instruction:</h3>
              <ul className='mt-4 space-y-2 text-sm list-disc overflow-clip break-words'>
                <li>
                  Go to a{' '}
                  <a
                    href={`https://admin.shopify.com/store/${storeName}/themes/current/editor?context=apps`}
                    target='_blank'
                    rel='noreferrer'
                    className='text-[#005cc8]'
                  >
                    current theme
                  </a>
                </li>
                <li className='flex items-center gap-2'>
                  App Embeds <IonIcon name='chevron-forward-outline' />{' '}
                  <strong>Magbot - Chatbot</strong>{' '}
                  <IonIcon name='chevron-forward-outline' /> Enable
                </li>
              </ul>
            </div>
          </div>
        ) : (
          <div className='w-full max-w-lg'>
            <h3 className='text-lg mb-4 font-semibold'>Instruction:</h3>
            <p className='text-base font-medium'>
              Copy the code below and paste it before the end of the{' '}
              <code>&lt;/body&gt;</code> section.
            </p>

            <div className='mt-4 flex items-center gap-2'>
              {!isDomainVerified && (
                <div className='flex items-center gap-2 text-red-600 text-sm font-medium'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    fill='none'
                    viewBox='0 0 24 24'
                    strokeWidth={2}
                    stroke='currentColor'
                    className='w-5 h-5'
                  >
                    <path
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      d='M12 9v2m0 4h.01m-6.938 4h13.856c1.054 0 1.918-.816 1.994-1.85L21 18V6c0-1.054-.816-1.918-1.85-1.994L19 4H5C3.946 4 3.082 4.816 3.006 5.85L3 6v12c0 1.054.816 1.918 1.85 1.994L5 20z'
                    />
                  </svg>
                  Immediate Action: Need to publish
                </div>
              )}
            </div>

            <div className='relative mt-4 bg-gray-100 p-3 border border-gray-300 rounded-md text-sm font-mono overflow-x-auto'>
              <pre>
                <code>{scriptCode}</code>
              </pre>
              <button
                onClick={handleCopy}
                className='absolute top-2 right-2 bg-[#232328] rounded-[59px] text-white text-[14px] text-xs px-2 py-1'
              >
                {copied ? 'Copied!' : 'Copy'}
              </button>
            </div>
          </div>
        )}
      </>
    </div>
  )
}

export default PublishTab
